import React, { memo } from 'react';
import PropTypes from 'prop-types';

import {
  HeadCell,
  HeadRow,
  SortButton,
  SortIconDown,
  SortIconUp,
  SortIconWrapper,
  TableHead,
} from './styles';

const CurrencyYearArchiveRatesTableHead = memo(({ columns, sort, onSort }) => (
  <TableHead>
    <HeadRow>
      {columns.map(column => {
        const isActive = sort?.key === column.key;
        const direction = isActive ? sort.order : null;

        return (
          <HeadCell key={column.key} $columnCount={columns.length}>
            <SortButton
              type="button"
              data-sort={direction || undefined}
              onClick={() => onSort(column.key)}
            >
              <SortIconWrapper aria-hidden="true">
                <SortIconUp />
                <SortIconDown />
              </SortIconWrapper>
              {column.label}
            </SortButton>
          </HeadCell>
        );
      })}
    </HeadRow>
  </TableHead>
));

CurrencyYearArchiveRatesTableHead.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  sort: PropTypes.shape({
    key: PropTypes.string,
    order: PropTypes.oneOf(['asc', 'desc']),
  }).isRequired,
  onSort: PropTypes.func.isRequired,
};

export default CurrencyYearArchiveRatesTableHead;
